module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "w-6 h-6 stroke-current text-blue-dark"
  }, [_c('g', {
    staticClass: "nc-icon-wrapper",
    attrs: {
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20.5 4.5h2v19h-20v-19h2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M14.5 3.5a2 2 0 1 0-4 0h-3v4h10v-4h-3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "data-color": "color-2",
      "d": "M7.5 11.5h10M7.5 15.5h10M7.5 19.5h4"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34601287","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navbar/sidemenu/svgs/OrderSVG.vue
// module id = 613
// module chunks = 66